export default "__VITE_ASSET__Do3Tv6T8__"